var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37.147,
    height: 35.499,
    viewBox: "0 0 37.147 35.499",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "pts",
    d: "M430.073,233.453l-10.746-1.561-4.806-9.738a1.722,1.722,0,0,0-3.089,0l-4.806,9.738-10.746,1.561a1.723,1.723,0,0,0-.955,2.938l7.776,7.58-1.835,10.7a1.718,1.718,0,0,0,2.5,1.816l9.611-5.053,9.612,5.053a1.718,1.718,0,0,0,2.5-1.816l-1.835-10.7,7.776-7.58A1.722,1.722,0,0,0,430.073,233.453Zm-9.964,7.295-1.7,1.652.4,2.333.884,5.152-4.628-2.432-2.095-1.1-2.095,1.1-4.627,2.432.884-5.152.4-2.333-1.7-1.652L402.1,237.1l5.173-.752,2.342-.34,1.047-2.122,2.314-4.688,2.314,4.688,1.047,2.122,2.342.34,5.173.752Z",
    transform: "translate(-394.402 -221.194)",
    fill: "#029c27"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPts);
export default __webpack_public_path__ + "static/media/pts.8a7ca8f1e91920e1a9bce57787d004de.svg";
export { ForwardRef as ReactComponent };